import { Component, Input } from '@angular/core';
import { SecurityService } from 'src/app/security/security.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-live-map-loader',
  templateUrl: './live-map-loader.component.html',
  styleUrls: ['./live-map-loader.component.scss'],
  imports: [MatProgressSpinner, MatButton],
})
export class LiveMapLoaderComponent {
  @Input()
  message: string;
  @Input()
  loadErrorMessage: string;

  constructor(private securityService: SecurityService) {}

  onLogout() {
    this.securityService.logout();
  }
}
